import React from "react";
import styled from "styled-components";
import { SimpleTextInput } from "./simpleTextInput";

interface DatalistProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "onChange"> {
	id: string;
	value: string;
	onChange: (v: string) => void;
	placeholder?: string;
	options: string[];
	disabled?: boolean;
}
export const Datalist: React.FC<DatalistProps> = ({
	id,
	value,
	onChange,
	placeholder,
	options,
	disabled,
	...htmlProps
}) => {
	return (
		<Container {...htmlProps}>
			<SimpleTextInput
				placeholder={placeholder}
				list={id}
				value={value}
				onChange={(v) => {
					onChange(v);
				}}
			/>
			<datalist id={id}>
				{options.map((opt) => (
					<option key={opt} value={opt}>
						{opt}
					</option>
				))}
			</datalist>
		</Container>
	);
};

const Container = styled.div``;
